import { Button } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';
import { PrintIncomeReportRouter } from '@flows/private/financial/pages/PrintIncomeReport/router';

import type { PrintButtonProps } from './types';

export function PrintButton({
  isLoading,
  hasData,
  selectedYear,
}: Readonly<PrintButtonProps>) {
  const { isDesktop } = useDeviceBreakpoints();

  const isDisabled = isLoading || !hasData;

  const handleNavigate = () => {
    window.open(
      PrintIncomeReportRouter.dynamicPath({ year: selectedYear }),
      '_blank',
    );
  };

  const getContent = () => {
    if (isDesktop) {
      return 'Imprimir';
    }

    return (
      <Icon
        name="navigation-b2b-print"
        size={20}
        color={isDisabled ? NEW_COLORS.GRAYSCALE[400] : NEW_COLORS.BASE.WHITE}
      />
    );
  };

  const getEndIcon = () => {
    if (!isDesktop) {
      return null;
    }
    return (
      <Icon
        name="navigation-b2b-print"
        size={20}
        color={isDisabled ? NEW_COLORS.GRAYSCALE[400] : NEW_COLORS.BASE.WHITE}
      />
    );
  };

  return (
    <Button
      onClick={handleNavigate}
      disabled={isDisabled}
      variant="contained"
      color="secondary"
      fullWidth
      endIcon={getEndIcon()}
    >
      {getContent()}
    </Button>
  );
}
